const topFirst = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    // const secFirst = document.querySelector('#jsSecFirst');
    const secMain = document.querySelector('#jsSecMain');

    // let swiper

    // {
    //   const mainWrap = secFirst.querySelector('.js-main-wrap');
    //   const mainArea = mainWrap.querySelector('.js-main-area');
    //   let swiperEl = mainArea.querySelector('.js-swiper');
    //   // let prevEl = mainArea.querySelector('.js-swiper-button-prev');
    //   // let nextEl = mainArea.querySelector('.js-swiper-button-next');
    //   // let paginationEl = mainArea.querySelector('.js-swiper-pagination');

    //   swiper = new Swiper(swiperEl, {
    //     effect: 'fade', // フェードモードにする（デフォルトは 'slide'）
    //     fadeEffect: {
    //       crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
    //     },

    //     slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    //     spaceBetween: 0, // スライド間の余白（px）
    //     centeredSlides: true, // アクティブなスライドを中央に配置する

    //     loop: true,  // 無限ループさせる
    //     loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数

    //     speed: 1000, // スライドアニメーションのスピード（ミリ秒）

    //     autoplay: { // 自動再生させる
    //       delay: 5000, // 次のスライドに切り替わるまでの時間（ミリ秒）
    //       disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
    //       waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    //     },

    //     // grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
    //     // watchSlidesProgress: true, // スライドの進行状況を監視する

    //     // pagination: {
    //     //   el: paginationEl, // ページネーション要素のクラス
    //     //   clickable: true, // クリックによるスライド切り替えを有効にする
    //     //   type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    //     // },

    //     // navigation: {
    //     //   nextEl: nextEl, // 「次へ」ボタン要素のクラス
    //     //   prevEl: prevEl, // 「前へ」ボタン要素のクラス
    //     // },

    //     // scrollbar: {
    //     //   el: '.swiper-scrollbar', // スクロールバー要素のクラス
    //     // },

    //     // thumbs: {
    //     //   swiper: mySwiper2 // サムネイルのスライダーのインスタンス名
    //     // },

    //     // breakpoints: { // ブレークポイント
    //     //   600: { // 画面幅600px以上で適用
    //     //     slidesPerView: 2,
    //     //   },
    //     //   1025: { // 画面幅1025px以上で適用
    //     //     slidesPerView: 4,
    //     //     spaceBetween: 32,
    //     //   }
    //     // },

    //     // on: { // イベントを登録する
    //     //   slideChange: (swiper) => {
    //     //     console.log('Slide index changed to: ' + (swiper.realIndex + 1));
    //     //   },
    //     // },
    //   });
    // }



    // {
    //   ScrollTrigger.create({
    //     invalidateOnRefresh: true,
    //     trigger: '#jsSecMain',
    //     start: '0% -10%',
    //     endTrigger: 'body',
    //     end: '100% 0%',
    //     toggleClass: { targets: "#jsSecFirst", className: "is-none" },
    //     onEnter: () => swiper.autoplay.stop(),
    //     // onLeave: () => console.log("onLeave"),
    //     // onEnterBack: () => console.log("onEnterBack"),
    //     onLeaveBack: () => swiper.autoplay.start(),
    //     // markers: true
    //   });
    // }



    {
      // ScrollTrigger.create({
      //   invalidateOnRefresh: true,
      //   trigger: '#jsSecMain', //アニメーションが始まるトリガーとなる要素
      //   start: '0% -10%',
      //   endTrigger: 'body',
      //   end: '100% 0%',
      //   toggleClass: { targets: "#jsSecMain .js-main-wrap", className: "is-act" },
      //   // markers: true
      // });

      gsap.set('#jsSecMain .js-main-wrap .js-copy-box img', {
        autoAlpha: 0,
        xPercent: -6,
      });
      gsap.set('#jsSecMain .js-main-wrap .js-img-box .img.on', {
        autoAlpha: 0,
      });

      // let tl = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: '#jsSecMain',
      //     start: '0% -10%',
      //     endTrigger: 'body',
      //     end: '100% 0%',
      //     toggleActions: 'play none none reverse',
      //     // markers: true
      //   },
      // });

      let tl = gsap.timeline({
      });

      tl.to('#jsSecMain .js-main-wrap .js-copy-box img', {
        autoAlpha: 1,
        xPercent: 0,
        duration: 1.2,
        ease: "power2.out",
        delay: 1,
        stagger: 0.2, // 0.02秒ごとに出現
      })
        .to('#jsSecMain .js-main-wrap .js-img-box .img.on', {
          autoAlpha: 1,
          duration: 2,
          ease: "power2.out",
        }, '> -0.25')
    }



    // {
    //   const mainWrap = secFirst.querySelector('.js-main-wrap');
    //   const logoArea = mainWrap.querySelector('.js-logo-area');
    //   const logoBox = logoArea.querySelector('.js-logo-box');
    //   const maskBox = logoArea.querySelector('.js-mask-box');
    //   const path = maskBox.querySelector('.mask-box svg path');
    //   // console.log(box)
    //   let sW = window.innerWidth;

    //   if (sW > 768) {

    //     path.addEventListener('mouseover', function () {
    //       logoBox.classList.add('is-act')
    //     });

    //     path.addEventListener('mouseleave', function () {
    //       logoBox.classList.remove('is-act')
    //     });

    //   } else {

    //     path.addEventListener('click', () => {
    //       if (logoBox.classList.contains('is-act') == true) {
    //         logoBox.classList.remove('is-act')
    //       } else {
    //         logoBox.classList.add('is-act')
    //       }
    //     });

    //     path.addEventListener('mouseleave', function () {
    //       logoBox.classList.remove('is-act')
    //     });

    //   }
    // }



  }
})()
export default topFirst;